export class ListenerNotFoundError extends Error {
  constructor() {
    super('listener not found')
  }
}
